import React, { Component } from 'react';
import { FiMenu, MdClose, MdSettings } from 'react-icons/all';
import { DataViewType, PopupType } from '../popup/model';
import Setting from '../setting/container'
import * as nodePath from 'path';
import "./style.css";
import "./style.mobile.css";

export default class Menubar extends Component {

     getMenuItemsView(menuItem) {
        if (menuItem == null || menuItem.length == 0) return;
        return menuItem.map((v) => {
            return <div className="menu-item">
                <div className="item-title" onClick={() => this.props.loadContent(v.type ?? PopupType.RENDER, {
                    data: v.url,
                })}>
                    {v.title}
                </div>
                {
                    v.child == null ? "" : <div className="item-sub-menu">
                        {this.getMenuItemsView(v.child)}
                    </div>
                }
            </div>
        })
    }

    getSettingBtnView() {
        return <div className="setting-btn">
            <MdSettings onClick={() => this.props.openSetting()} />
        </div>
    }

    render() {
        var { goHomePage, isExpandMenu, setMenuStatus, nav_isCollapseNav, setting_isWidescreenOn } = this.props;
        var menuMobileStatusHidden = isExpandMenu ? " menu-status-expand" : "";
        var navStatusCollapse = nav_isCollapseNav ? "" : " nav-status-expand";
        var menuStatusSettingHidden = setting_isWidescreenOn & nav_isCollapseNav ? " setting-autowide" : "";

        return (
            <div className={"menu-place" + menuMobileStatusHidden + navStatusCollapse + menuStatusSettingHidden}>
                <div className="logo">
                    <img src={nodePath.join(`${process.env.PUBLIC_URL}/data/`, window.config.logo?.url)} onLoad={() => this.forceUpdate()} onClick={goHomePage} />
                </div>
                <div className="menu-bar">
                    {this.getMenuItemsView.call(this, window.config.menubar)}
                </div>
                <div className="menu-collapse-btn" onClick={() => setMenuStatus(!isExpandMenu)}>
                    {isExpandMenu ? <MdClose /> : <FiMenu />}
                </div>
                {this.getSettingBtnView.call(this)}
            </div >
        )
    }
}
